export type CoachAvailabilityWeekRanges = {
  currentWeekStart: Date;
  currentWeekEnd: Date;
  nextWeekStart: Date;
  nextWeekEnd: Date;
  afterNextWeekStart: Date;
  afterNextWeekEnd: Date;
};

export type DateGroup = {
  [key: string]: string[];
};

export type OrderTableData = {
  orderId: string;
  orderData: string;
  orderAmount: string;
  courtName: string;
  createdAtData: string;
};

export type CourtType = {
  id: CourtId;
  title: string;
};

export enum CourtId {
  Indoor = 1,
  Outdoor,
  Singles,
  IndoorLegacy,
}

export type UserRole = {
  value: number;
  paths: string[];
};

export type LoyaltyQRReedemData = { Id: number; Name: string; UserId: string };

export type Avatar = {
  image: string;
  name: string;
};

export interface DateInfo {
  date: string;
  day: string;
  month: string;
  fullDate: Date;
}
